import { useFooterData } from '@/hooks/useFooterData';
import { resolveImagePath } from '@/utils/imageMap';

export function Footer() {
  const { footerData } = useFooterData();

  return (
    <footer id="qodef-page-footer" className="bg-gray-900 text-white">
      {/* Footer Top Area */}
      <div id="qodef-page-footer-top-area" className="py-16">
        <div id="qodef-page-footer-top-area-inner" className="container mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            
            {/* Company Info Column */}
            <div className="lg:col-span-2">
              <div className="mb-6">
                <a href="/" className="inline-block">
                  <img 
                    src={resolveImagePath('/images/logo.png')} 
                    alt="Concierge Couples Counseling"
                    className="h-16 w-auto"
                  />
                </a>
              </div>
              
              <div className="mb-6">
                <p className="text-gray-300 leading-relaxed mb-6">
                  {footerData.companyInfo.description}
                </p>
                
                <div className="space-y-2">
                  <p className="text-gray-300">
                    <strong className="text-white">Phone: </strong>
                    <a 
                      href={`tel:${footerData.companyInfo.phone.replace(/[^0-9]/g, '')}`}
                      className="hover:text-gray-200 transition-colors"
                    >
                      {footerData.companyInfo.phone}
                    </a>
                  </p>
                  <p className="text-gray-300">
                    <strong className="text-white">Email: </strong>
                    <a 
                      href={`mailto:${footerData.companyInfo.email}`}
                      className="hover:text-gray-200 transition-colors"
                    >
                      {footerData.companyInfo.email}
                    </a>
                  </p>
                </div>
              </div>
            </div>

            {/* Quick Links Column */}
            <div>
              <h5 className="text-white font-semibold mb-6 text-lg">Quick Links</h5>
              <ul id="menu-footer-ii-column" className="space-y-3">
                {footerData.quickLinks.map((link, index) => (
                  <li key={`quick-link-${index}`} className="menu-item">
                    <a 
                      href={link.href}
                      className="text-gray-300 hover:text-white transition-colors text-sm"
                    >
                      {link.text}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Services Column */}
            <div>
              <h5 className="text-white font-semibold mb-6 text-lg">Services</h5>
              <ul id="menu-footer-iii-column" className="space-y-3">
                {footerData.services.map((service, index) => (
                  <li key={`service-${index}`} className="menu-item">
                    <a 
                      href={service.href}
                      className="text-gray-300 hover:text-white transition-colors text-sm"
                    >
                      {service.text}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom Area */}
      <div id="qodef-page-footer-bottom-area" className="bg-gray-800 py-6">
        <div id="qodef-page-footer-bottom-area-inner" className="container mx-auto px-6">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-center md:text-left">
              <p className="text-gray-400 text-sm">
                {footerData.copyright}
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}